import BigThreeElements from './BigThreeElements';
import EightIndicators from './EightIndicators';
import Intro from './Intro';
import ScoreCard from './ScoreCard';
import WhyFocus from './WhyFocus';
import Responses from './Responses';
import Profile from './Profile';
import { PREVIOUS_STAGE_KEY } from 'utils/app-constants';
import localStorage from 'utils/localStorage';
import Auth from 'shared/Auth';

setTimeout(() => {
  console.log('initial mount');
  console.log('This will run after 1 second!');
}, 1000);

export const CDRComponentMap = [
  {
    component: Responses,
    label: true,
    transaltionRef: 'StageOneLabel',
    name: 'CDR Section',
  },

  // {
  //   component: Intro,
  //   route: '5b7a91a6ff26',
  //   label: false,
  //   transaltionRef: '0',
  //   name: 'Why Capacity Diagnostic Report',
  // },
  // {
  //   component: WhyFocus,
  //   route: 'why-focus',
  //   label: false,
  //   transaltionRef: '1',
  //   name: 'Why Focus on Organisational Capacity',
  // },

  {
    component: EightIndicators,
    route: '5b7a91a6ff26',
    label: false,
    transaltionRef: '2',
    name: 'How You Performed',
  },
  // {
  //   component: BigThreeElements,
  //   route: 'big-three-elements',
  //   label: false,
  //   transaltionRef: '3',
  //   name: 'Our “big 3” Capacity Elements',
  // },
  // {
  //   component: ScoreCard,
  //   route: 'score-card',
  //   label: false,
  //   transaltionRef: '4',
  //   name: 'Score Card Questions',
  // },
  {
    component: Responses,
    route: localStorage.getItem(PREVIOUS_STAGE_KEY),
    label: false,
    transaltionRef: '4',
    name: 'Question Responses',
  },
  {
    component: Profile,
    route: 'profile',
    label: false,
    transaltionRef: '0',
    name: 'Profile',
  },
];



// WEBPACK FOOTER //
// ./src/components/CDRSections/CDRComponentMap.js